module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (
        _vm.globals.isAccessAllowed('LoopOp_Surveys_Read') &&
        _vm.globals.isAccessAllowed('LoopOp_Surveys_Update')
      ),
      expression: "\n      globals.isAccessAllowed('LoopOp_Surveys_Read') &&\n      globals.isAccessAllowed('LoopOp_Surveys_Update')\n    "
    }],
    attrs: {
      "id": "surveyEditorContainer"
    }
  }), _vm._v(" "), _c('svg', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('symbol', {
    attrs: {
      "width": "16",
      "height": "16",
      "viewBox": "0 0 24 24",
      "id": "icon-actionsecurity"
    }
  }, [_c('path', {
    attrs: {
      "d": "M18 10v-4c0-3.313-2.687-6-6-6s-6 2.687-6 6v4h-3v14h18v-14h-3zm-5 7.723v2.277h-2v-2.277c-.595-.347-1-.984-1-1.723 0-1.104.896-2 2-2s2 .896 2 2c0 .738-.404 1.376-1 1.723zm-5-7.723v-4c0-2.206 1.794-4 4-4 2.205 0 4 1.794 4 4v4h-8z"
    }
  })])]), _vm._v(" "), (_vm.selectedSurveyElement && _vm.surveyElementSecurityModalVisible) ? _c('SurveyElementSecurityModal', {
    attrs: {
      "modalVisible": _vm.surveyElementSecurityModalVisible,
      "surveyElement": _vm.selectedSurveyElement,
      "surveyData": _vm.surveyData,
      "surveyId": _vm.surveyId
    },
    on: {
      "saveSecuritySettings": _vm.saveSurveyElementSecuritySettings,
      "closeModal": function($event) {
        _vm.surveyElementSecurityModalVisible = false
      }
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6e068fdd","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/SurveyEditor/SurveyEditor.vue
// module id = 1693
// module chunks = 1